<template>
  <div class="product-bind">
    <div v-for="(item, index) in incentiveList" :key="index" class="event-card">
      <div class="card-header">
        <span class="status-tag txt-ellipsis" :style="{ 'color': item.jobColor, 'border': `1px solid ${item.jobColor}` }">{{ item.job }}</span>
        <span class="event-title txt-ellipsis">{{ item.nickname }}</span>
        <span class="point-integral txt-ellipsis">{{ $t('shared.point') }}：{{ item.integral }}</span>
      </div>

      <div class="store-info">
        <img src="@/assets/images/store.png" class="row-icon" />
        <span class="store-name van-ellipsis">{{ item.customerName }}</span>
      </div>
      <div class="btn-oper">
        <div class="exchange-btn" @click.stop="toUrl(`/pointsExchange?employeeId=${item.id}&customerId=${item.customerId}`)">
          <img src="@/assets/images/gift.png" alt="">
          <span>{{ $t('button.exchange') }}</span>
        </div>
      </div>
      <!-- <div class="incentive-num txt-ellipsis">+{{ item.totalIntegral }}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    incentiveList: {
      type: Array,
      default: () => {}
    }
  },
  methods: {
    toUrl (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.product-bind {
  .event-card {
    background: #fff;
    padding: 10px;
    border-bottom: 1px solid rgb(238, 229, 229);
    &:first-child {
      border-top: 1px solid rgb(238, 229, 229);
    }
    .card-header {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .event-title {
        flex: 1;
        font-size: 13px;
        color: #333;
        margin-right: 8px;
      }

      .status-tag {
        max-width: 70px;
        font-size: 10px;
        padding: 2px 6px;
        border-radius: 2px;
        color: #307bff;
        border: 1px solid #307bff;
        margin-right: 5px;
      }
      .point-integral {
        max-width: 86px;
        font-size: 13px;
        text-align: right;
        color: #307bff;
        font-weight: bold;
      }
    }

    .store-info {
      display: flex;
      align-items: center;
      .store-name {
        flex: 1;
        font-size: 12px;
        color: #555555;
      }
    }

    .btn-oper {
      display: flex;
      justify-content: flex-end;
      margin-top: 8px;
      .exchange-btn {
        display: flex;
        padding: 2px 3px;
        border: 1px solid #307bff;
        color: #307bff;
        >img {
          width: 13px;
          height: 13px;
          margin-right: 3px;
        }
      }
    }

    .row-icon {
      width: 13px;
      height: 13px;
      margin-right: 6px;
      object-fit: contain;
    }
    .incentive-num {
      max-width: 74px;
      font-size: 15px;
      color: #307bff;
      font-weight: bold;
      text-align: right;
    }
  }
}
</style>
